import React from "react";
import { Itinerary } from "../../types";
import { addDaysToDate, formatDate } from "../../functions/Utils";
import IconComponent from "../IconComponent";
import { FaAngleDown, FaAngleUp, FaHotel } from "react-icons/fa6";
import { Card, Collapse } from "react-bootstrap";

interface ItineraryTripDaysProps {
    itinerary: Itinerary;
    setSelectedDay: Function;
    pathname: string;
    setOpenStepId: Function;
    openStepId: number | null;
}

const ItineraryTripDays: React.FC<ItineraryTripDaysProps> = ({itinerary, setSelectedDay, pathname, setOpenStepId, openStepId}) => {

    return (
        <div className="card-body">
          {itinerary &&
            itinerary.data &&
            itinerary.data.trip_days.map((day: any) => (
              <div
                key={day.id}
                className="card my-3 border-0 rounded-4"
                onClick={() => setSelectedDay(day)}
                style={{ cursor: "pointer" }}
              >
                <div className="card-body">
                  <span className="float-end badge bg-info">
                    Day {day.id}
                    {itinerary.data.departure_date
                      ? ` > ${formatDate(
                          addDaysToDate(
                            itinerary.data.departure_date,
                            day.id - 1
                          )
                        )}`
                      : ""}
                  </span>
                  <h5 className="card-title fw-bold">
                    {day.hotel && (
                      <span
                        className={`me-1 fi fi-${day.hotel.country_code.toLocaleLowerCase()}`}
                      ></span>
                    )}
                    {day.country_code && (
                      <span
                        className={`me-1 fi fi-${day.country_code.toLocaleLowerCase()}`}
                      ></span>
                    )}
                    {day.title}
                  </h5>

                  {day.hotel && (
                    <p className="text-muted">
                      <IconComponent
                        icon={FaHotel}
                        size={14}
                        className="me-1"
                      />
                      {day.hotel.cityname}
                    </p>
                  )}

                  <p className="card-text">{day.description}</p>
                </div>

                {/* {pathname == "itinerary" && itinerary && (
                  <div>
                    <div
                      className="float-end text-secondary me-2 mb-2"
                      onClick={() =>
                        setOpenStepId(openStepId === day.id ? null : day.id)
                      }
                    >
                      {openStepId === day.id ? (
                        <IconComponent icon={FaAngleUp} className="" />
                      ) : (
                        <IconComponent icon={FaAngleDown} className="" />
                      )}
                    </div>

                    <Collapse in={openStepId === day.id}>
                      <div>
                        <Card.Body>
                          <Card.Text>{day.description}</Card.Text>
                        </Card.Body>
                      </div>
                    </Collapse>
                  </div>
                )} */}
              </div>
            ))}
        </div>
    )
}

export default ItineraryTripDays;